import { HTMLProps } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export const FooterInfoLinks = (props: HTMLProps<HTMLDivElement>) => {
  const { t } = useTranslation();

  return (
    <div {...props}>
      <div className='footer-widget footer-menu-widget clearfix'>
        <h4 className='footer-title'>{t('footer.information')}</h4>
        <div className='footer-menu'>
          <ul>
            <li>
              <Link to='/wishlist'>{t('footer.wishList')}</Link>
            </li>
            <li>
              <Link to='/about'>{t('footer.about')}</Link>
            </li>
            <li>
              <Link to='/contact'>{t('footer.contactUs')}</Link>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};
